@if (afterViewInit) {
<nz-tabset
           (nzSelectedIndexChange)="closeAllDrawers()"
           [class.padding]="withPadding" [nzSelectedIndex]="activeTabIndex">
  @for (tab of tabs; track tab.name) {
    <nz-tab [nzTitle]="titleTemplate">
      <ng-template #titleTemplate>
        <app-st-icon style="margin-right: 5px" [name]="tab.icon"></app-st-icon>
        {{ tab.name }}
      </ng-template>

      <!-- Contenido de la pestaña -->
      <ng-container *ngTemplateOutlet="tab.tmpl"></ng-container>
    </nz-tab>
  }
</nz-tabset>
}

<ng-template #serviceTmpl>
  <div class="tab-content" [ngClass]="(isMobile$ | async) && showServiceFilters ? 'gap-200' : 'gap-100'">
<!--    <h3 style="margin-bottom: 10px" class="text-header-24">Servicios</h3>-->

    @if (!!project.services?.length) {
      <div class="flex-center-between">
        <div class="btns-mobile">
          <button (click)="openCreateServiceDrawer()" class="text-btn-16 flex-center" nz-button nzType="default" nzShape="circle"
                  nzSize="default">
            <app-st-icon [name]="'add'" [bold]="true"></app-st-icon>
          </button>

          <button (click)="toggleShowFilters()" class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="default">
            <app-st-icon class="prefix" [name]="'filter_alt'" [bold]="true"></app-st-icon>
            <span>Filtros</span>
          </button>
        </div>

        <!-- Filtros (Desktop) -->
        @if (!(isMobile$ | async)) {
          <ng-container [ngTemplateOutlet]="filtersTmpl"></ng-container>
        }

        @if (!!authService.loggedUser$.value?.createService) {
          <button
                  (click)="openCreateServiceDrawer()" class="text-btn-14" nz-button nzType="primary"
                  nzShape="round" nzSize="default">
            <app-st-icon class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
            <span>Añadir</span>
          </button>
        }
      </div>
    }

    <!-- Filtros (Mobile) -->
    @if ((isMobile$ | async)) {
      <ng-container [ngTemplateOutlet]="filtersTmpl"></ng-container>
    }

    <div class="flex flex-column gap-100">
      @for (service of showServices; track service.id) {
        <app-info-card
          (click)="emitNavigateEvent()"
          [routerLink]="['/projects', 'detail', project.id, 'service', service.id]"
          [name]="service.name || 'Sin nombre'"
          [isAlert]="service.hasFlow === false"
          [date]="service.startDatePlan"
          [icon]="gs.getServiceType(service.typeId || 0)?.icon || 'close'"
          [totalOrders]="service.serviceOrders?.length"
          [completedOrders]="service.serviceOrders?.length"
          [origin]="getLocation(service.originId)"
          [isActive]="selectedService?.id === service.id"
          [destination]="getLocation(service.destinationId)"
          [supplierId]="service.supplierId"
          [supplierIds]="getResolvedSuppliers(service).supplierIds"
          [suppliers]="getResolvedSuppliers(service).suppliers"
          [checkboxConfig]="{show: true, isChecked: selectedServicesIds.has(service.id)}"
          (checkboxEvent)="toggleSelectService(service.id)"
          [actions]="{
                copy: false,
                file: false,
                message: false,
                drawer: false,
                select: false
              }"
        ></app-info-card>
      } @empty {
        <app-empty-state [icon]="'checklist'" (btnPressEvent)="openCreateServiceDrawer()"
                         [hideBtn]="!authService.loggedUser$.value?.createService"
                        [object]="'servicios'" [btnIcon]="'upload'" [btnText]="'Añadir servicios'"></app-empty-state>
      }
    </div>
  </div>
</ng-template>

<ng-template #docTmpl>
  <div class="tab-content gap-200">
<!--    <h3 *ngIf="!(isMobile$ | async)" class="text-header-24">Documentos</h3>-->

    <app-doc-section
      [entityType]="'Project'"
      [entityId]="project.id"
      [documents]="project.documents || []"
      (isDocDrawerOpen)="sendIsDocDrawerOpen($event)"
    ></app-doc-section>
  </div>
</ng-template>

<ng-template #teamTmpl>
  <div class="tab-content">
    <h3 class="text-header-24">Equipo</h3>
  </div>
</ng-template>

<ng-template #inboxTmpl>
  <div class="tab-content">
    <h3 class="text-header-24">Inbox</h3>
  </div>
</ng-template>

<ng-template #filtersTmpl>
  <div [class.hidden]="(isMobile$ | async) && !showServiceFilters" class="filter-cont flex-center gap-150">
    @for (filter of servicesFilters; track filter) {
      <div class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'" [nzDropdownMenu]="serviceTypeMenu"
           nz-dropdown [nzTrigger]="'click'">
        @if (filter.icon !== '') {
          <app-st-icon [name]="filter.icon"></app-st-icon>
        }
        <label>{{filter.name}}</label>
      </div>
      <nz-dropdown-menu #serviceTypeMenu="nzDropdownMenu">
        <ul nz-menu style="max-height: 500px; overflow: auto">
          @for (type of servOnlyOnProject; track type) {
            <li nz-menu-item [class.bg-grey-1]="type.id === serviceTypeFiltervalue"
                (click)="onFilterSelect(type.id)">
              {{ type.name }}
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    }

    @for (filter of providersFilters; track filter) {
      <div class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'"
           [nzDropdownMenu]="providerMenu" nz-dropdown [nzTrigger]="'click'">
        @if (filter.icon !== '') {
          <app-st-icon [name]="filter.icon"></app-st-icon>
        }
        <label>{{filter.name}}</label>
      </div>
      <nz-dropdown-menu #providerMenu="nzDropdownMenu">
        <ul nz-menu style="max-height: 500px; overflow: auto">
          @for (provider of providersOnlyOnProject; track provider) {
            <li nz-menu-item [class.bg-grey-1]="provider.id === providerFilterValue"
                (click)="onProviderFilterSelect(provider.id)">
              {{ provider.name }}{{provider.surName}}
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    }
  </div>
</ng-template>

<ng-template #containersTmpl>
  <div class="tab-content gap-200">
<!--    <h3 class="text-header-24">Contenedores</h3>-->
    <app-container-section></app-container-section>
  </div>
</ng-template>


